import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PartnerUserProfileService } from './services/partner-user-profile.service';
import { UserDataService } from './services/user-data.service';

@NgModule({
	imports: [CommonModule],
	providers: [UserDataService, PartnerUserProfileService]
})
export class UserDataModule { }
